import axios from 'axios';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS,
  FETCH_PURCHASING_PERFORMANCE_FAILURE,
} from './type';

import {
  PURCHASE_URL,
} from './url';

export function fetchPurchasePerformanceByFilter(days, fromDate, toDate, type, POStatus, Vendor_id, ProductNum) {
  console.log('fetching dude', Vendor_id, ProductNum)
  const dates = toFromDates(days, fromDate, toDate);
  console.log('yo here are the dates', dates);
  let searchBy;
  if (Vendor_id) {
    Vendor_id = Vendor_id.value || Vendor_id;
    searchBy = `Vendor_id/${Vendor_id}/`;
  } else {
    searchBy = `ProductNum/${ProductNum}/`;
  }
  if (POStatus) {
    POStatus = POStatus.value || POStatus;
    POStatus = `&PurchaseStatus=${POStatus}`;
  } else {
    POStatus = '&PurchaseStatus=All';
  }
  return (dispatch) => {
    dispatch({
      type: REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
      payload: {
        Vendor_id,
        dates,
        POStatus,
        searchBy,
      },
    });
  };
}

export const PurchasingPerformanceListEpic = action$ =>
  action$.ofType(REQUEST_PURCHASING_PERFORMANCE_BY_FILTER)
    .switchMap(action =>
      axios.get(
        `${PURCHASE_URL}performance/${action.payload.searchBy}?OrderDate__gte=${action.payload.dates.fromDate}&OrderDate__lte=${action.payload.dates.toDate}${action.payload.POStatus}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_PURCHASING_PERFORMANCE_SUCCESS, payload: response }))
    .catch(err => ({ type: FETCH_PURCHASING_PERFORMANCE_FAILURE, payload: err }));


// WEBPACK FOOTER //
// ./master/jsx/actions/purchasingPerformanceList_actions.js